const API_BASE = import.meta.env.VITE_API_URL || '';

export function resolveMiniGameAssetSrc(value) {
  const raw = String(value || '').trim();
  if (!raw) return '';
  if (/^https?:\/\//i.test(raw) || raw.startsWith('blob:') || raw.startsWith('/')) return raw;
  return `${API_BASE}/uploads/gallery/${raw}`;
}

export function parseMiniGameAssetList(value) {
  if (Array.isArray(value)) {
    return value.map((entry) => String(entry || '').trim()).filter(Boolean);
  }

  const raw = String(value || '').trim();
  if (!raw) return [];

  return raw
    .split(/[\n,;]+/g)
    .map((entry) => String(entry || '').trim())
    .filter(Boolean);
}

export function normalizeMiniGameNaveAssets(raw = {}) {
  const source = raw && typeof raw === 'object' ? raw : {};
  return {
    background_image: String(source.background_image || source.background || '').trim(),
    player_image: String(source.player_image || source.playerSprite || '').trim(),
    enemy_images: parseMiniGameAssetList(source.enemy_images || source.enemySprites || source.enemy_image || source.enemySprite || []),
    bullet_image: String(source.bullet_image || source.bullet || '').trim(),
    explosion_image: String(source.explosion_image || source.explosion || '').trim()
  };
}
